<template>
  <div class="AppImg">
    <slot name="placeholder" v-if="!src">
      <div class="AppImg_placeholder"></div>
    </slot>
    <img
      v-else
      :src="src"
      :alt="alt"
    >
  </div>
</template>

<script setup>

defineOptions({
  name: 'AppImg'
});

const props = defineProps({
  src: {
    type: String,
    default: null
  },
  alt: {
    type: String,
    default: 'image'
  }
});
</script>

<style lang="scss">
  .AppImg {
    position: releative;
    max-width: 100%;
    border-radius: .04rem;
    overflow: hidden;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &_placeholder {
      background: $grey-200;
      width: 100%;
      height: 100%;
    }

    img {
      width: 100%;
      height: auto;
    }
  }
</style>
